export default __webpack_public_path__ + "static/media/poster(bobo).ea4c7c77.png";